import React from 'react';
const SvgArrowUp: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 16.5l-9.011-9L3 16.5"
      />
    </svg>
  );
};
export default SvgArrowUp;
